export var ConfigurationScope = /*#__PURE__*/function (ConfigurationScope) {
  ConfigurationScope["PUBLIC"] = "public";
  ConfigurationScope["PRIVATE"] = "private";
  return ConfigurationScope;
}(ConfigurationScope || {});
export const applicationsList = [{
  display: 'MENTOR',
  value: 'waterford-parent'
}, {
  display: 'UPSTART',
  value: 'waterford-upstart'
}, {
  display: 'TEACHER',
  value: 'waterford-teacher'
}, {
  display: 'STUDENT',
  value: 'waterford-student'
}, {
  display: 'ADMIN',
  value: 'waterford-admin'
}, {
  display: 'GLOBAL',
  value: 'global'
}];
export var ConfigurationEventType = /*#__PURE__*/function (ConfigurationEventType) {
  ConfigurationEventType["DELETE"] = "DELETE";
  ConfigurationEventType["UPDATE"] = "UPDATE";
  ConfigurationEventType["CREATE"] = "CREATE";
  return ConfigurationEventType;
}(ConfigurationEventType || {});

